import { Union, Record } from "../fable_modules/fable-library-js.4.29.0/Types.js";
import { Role, TrackInactiveOverview_$reflection, CompletedTask_$reflection, Workplace_$reflection, EnrolledTrack_$reflection, Track_$reflection } from "../Shared/SharedModels.jsx";
import { union_type, record_type, bool_type, array_type, option_type } from "../fable_modules/fable-library-js.4.29.0/Reflection.js";
import { tap } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { infoToast, successToast, errorToast } from "../Toasts.jsx";
import { map, collect, tryFind, append } from "../fable_modules/fable-library-js.4.29.0/Array.js";
import { startAsPromise } from "../fable_modules/fable-library-js.4.29.0/Async.js";
import { Workplace, Track, toastServerError, Task } from "../ApiClient.jsx";
import { createElement } from "react";
import React from "react";
import { useCtx } from "../Context.jsx";
import { ScreenSize, useFeliz_React__React_useResponsive_Static_Z434A9929 } from "../fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { createObj, safeHash, equals } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { bind } from "../fable_modules/fable-library-js.4.29.0/Option.js";
import { Array_distinct } from "../fable_modules/fable-library-js.4.29.0/Seq2.js";
import { SkeletonItem, Skeleton, PopoverSurface, PopoverTrigger, Popover, Link, DialogSurface, DialogBody, DialogActions, Body1, DialogContent, DialogTitle, DialogTrigger, Dialog, Spinner, Button, Tooltip, Label, Text as Text$, Caption1, ProgressBar, Field, Subtitle2, tokens, Image, CardPreview, Card } from "@fluentui/react-components";
import { take, length, tryHead, empty, singleton, append as append_1, delay, toList } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.29.0/String.js";
import { ImportantFilled, ArrowExitRegular, ArrowRightRegular, WarningFilled, LayerRegular, CertificateRegular, LayerDiagonalPersonRegular } from "@fluentui/react-icons";
import { singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { View } from "./TrackInactiveDialog.jsx";
import { RouterModule_nav } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { formatLevelsRoute } from "../QueryParameters.jsx";
import { useEffectOnce } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { TrackProgressProps, TrackProgress } from "./TrackProgress.jsx";
import { dataFetchFailedView } from "../Helpers.jsx";

class Model extends Record {
    constructor(Track, EnrolledTrack, WorkplaceTracks, IsFetching, CompletedTasks, IsInactive) {
        super();
        this.Track = Track;
        this.EnrolledTrack = EnrolledTrack;
        this.WorkplaceTracks = WorkplaceTracks;
        this.IsFetching = IsFetching;
        this.CompletedTasks = CompletedTasks;
        this.IsInactive = IsInactive;
    }
}

function Model_$reflection() {
    return record_type("Track.TrackView.Model", [], Model, () => [["Track", option_type(Track_$reflection())], ["EnrolledTrack", option_type(EnrolledTrack_$reflection())], ["WorkplaceTracks", array_type(Workplace_$reflection())], ["IsFetching", bool_type], ["CompletedTasks", array_type(CompletedTask_$reflection())], ["IsInactive", option_type(TrackInactiveOverview_$reflection())]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateTrack", "UpdateEnrolledTrack", "UpdateWorkplaceTracks", "UpdateIsFetching", "UpdateCompletedTasks", "UpdateIsInactive"];
    }
}

function Msg_$reflection() {
    return union_type("Track.TrackView.Msg", [], Msg, () => [[["Item", Track_$reflection()]], [["Item", option_type(EnrolledTrack_$reflection())]], [["Item", array_type(Workplace_$reflection())]], [["Item", bool_type]], [["Item", array_type(CompletedTask_$reflection())]], [["Item", option_type(TrackInactiveOverview_$reflection())]]]);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1:
            return new Model(model.Track, msg.fields[0], model.WorkplaceTracks, model.IsFetching, model.CompletedTasks, model.IsInactive);
        case 2:
            return new Model(model.Track, model.EnrolledTrack, msg.fields[0], model.IsFetching, model.CompletedTasks, model.IsInactive);
        case 3:
            return new Model(model.Track, model.EnrolledTrack, model.WorkplaceTracks, msg.fields[0], model.CompletedTasks, model.IsInactive);
        case 4:
            return new Model(model.Track, model.EnrolledTrack, model.WorkplaceTracks, model.IsFetching, msg.fields[0], model.IsInactive);
        case 5:
            return new Model(model.Track, model.EnrolledTrack, model.WorkplaceTracks, model.IsFetching, model.CompletedTasks, msg.fields[0]);
        default:
            return new Model(msg.fields[0], model.EnrolledTrack, model.WorkplaceTracks, model.IsFetching, model.CompletedTasks, model.IsInactive);
    }
}

function init(isInactive) {
    return new Model(undefined, undefined, [], true, [], isInactive);
}

function completeTrackLevelTask(taskId, userId, model, dispatch, setCtx) {
    const pr = tap((res) => {
        if (res.tag === 1) {
            switch (res.fields[0].tag) {
                case 1: {
                    errorToast(setCtx, "CompleteTrackLevelTaskTrackLevelNotFound", "Noe gikk galt", "Fant ikke nivået til denne oppgaven", undefined);
                    break;
                }
                case 2: {
                    errorToast(setCtx, "CompleteTrackLevelTaskUserNotFound", "Noe gikk galt", "Fant ikke bruker", undefined);
                    break;
                }
                default:
                    errorToast(setCtx, "CompleteTrackLevelTaskTaskNotFound", "Noe gikk galt", "Fant ikke oppgaven", undefined);
            }
        }
        else {
            dispatch(new Msg(4, [append([res.fields[0]], model.CompletedTasks)]));
            successToast(setCtx, "CompleteTrackLevelTaskSuccess", "Oppgave fullført", "");
        }
    }, startAsPromise(Task.CompleteTrackLevelTask(taskId, userId)));
    void (pr.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function removeTrackLevelTask(taskId, userId, model, dispatch, setCtx) {
    const pr = tap((res) => {
        if (res.tag === 1) {
            switch (res.fields[0].tag) {
                case 1: {
                    errorToast(setCtx, "CompleteTrackLevelTaskTrackLevelNotFound", "Noe gikk galt", "Fant ikke nivået til denne oppgaven", undefined);
                    break;
                }
                case 2: {
                    errorToast(setCtx, "CompleteTrackLevelTaskUserNotFound", "Noe gikk galt", "Fant ikke bruker", undefined);
                    break;
                }
                default:
                    errorToast(setCtx, "CompleteTrackLevelTaskTaskNotFound", "Noe gikk galt", "Fant ikke oppgaven", undefined);
            }
        }
        else {
            dispatch(new Msg(4, [model.CompletedTasks.filter((ct) => (ct.Task.Id !== taskId))]));
            successToast(setCtx, "RevokeTrackLevelTaskSuccess", "Oppgave oppdatert", "Oppgaven markert som ikke fullført");
        }
    }, startAsPromise(Task.RevokeTrackLevelTask(taskId, userId)));
    void (pr.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function HeaderCard(headerCardInputProps) {
    let elems_20, el_4, imgHeight, matchValue, imageUrl_1, el, elems, el_2, elems_19, elems_10, elems_5, elems_9, elems_18;
    const dispatch = headerCardInputProps.dispatch;
    const model = headerCardInputProps.model;
    const track = headerCardInputProps.track;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, []));
    const patternInput_1 = reactApi.useState(false);
    const setIsEnrollmentPending = patternInput_1[1];
    const isEnrollmentPending = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const setIsSignOffDialogOpen = patternInput_2[1];
    const currentLevel = bind((et) => tryFind((s) => (s.Id === et.CurrentTrackLevelId), track.TrackLevels), model.EnrolledTrack);
    const trackInWorkplace = model.WorkplaceTracks.some((wp) => wp.Tracks.some((tr) => (tr.Id === track.Id)));
    const allTasksInTrack = Array_distinct(collect((tl) => append(tl.Tasks, collect((_arg) => _arg.Course.Tasks, tl.TrackLevelCourses)), track.TrackLevels), {
        Equals: equals,
        GetHashCode: safeHash,
    });
    const el_90 = Card;
    return createElement(el_90, createObj(ofArray([["style", createObj(toList(delay(() => append_1(!isMobile ? singleton(["minHeight", 35 + "vh"]) : empty(), delay(() => append_1(singleton(["display", "flex"]), delay(() => append_1(isMobile ? singleton(["flexDirection", "column"]) : empty(), delay(() => append_1(singleton(["padding", 0]), delay(() => append_1(singleton(["minWidth", 0]), delay(() => singleton(["overflow", "hidden"]))))))))))))))], (elems_20 = [(el_4 = CardPreview, createElement(el_4, {
        children: (imgHeight = (isMobile ? (120 + "px") : (15 + "vh")), (matchValue = track.ImageUrl, (matchValue != null) ? (!isNullOrWhiteSpace(matchValue) ? ((imageUrl_1 = matchValue, (el = Image, createElement(el, {
            style: createObj(toList(delay(() => append_1(singleton(["height", imgHeight]), delay(() => (isMobile ? append_1(singleton(["width", 100 + "%"]), delay(() => singleton(["objectFit", "cover"]))) : empty())))))),
            fit: "cover",
            src: imageUrl_1,
        })))) : createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(singleton(["height", imgHeight]), delay(() => append_1(isMobile ? singleton(["width", 100 + "%"]) : empty(), delay(() => append_1(singleton(["display", "flex"]), delay(() => append_1(singleton(["alignItems", "center"]), delay(() => append_1(singleton(["justifyContent", "center"]), delay(() => singleton(["backgroundColor", tokens.colorNeutralBackground3]))))))))))))))], (elems = [(el_2 = LayerDiagonalPersonRegular, createElement(el_2, {
            style: {
                fontSize: (isMobile ? 56 : 96) + "px",
            },
            primaryFill: tokens.colorNeutralForeground3,
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(singleton(["height", imgHeight]), delay(() => append_1(isMobile ? singleton(["width", 100 + "%"]) : empty(), delay(() => append_1(singleton(["display", "flex"]), delay(() => append_1(singleton(["alignItems", "center"]), delay(() => append_1(singleton(["justifyContent", "center"]), delay(() => singleton(["backgroundColor", tokens.colorNeutralBackground3]))))))))))))))], (elems = [(el_2 = LayerDiagonalPersonRegular, createElement(el_2, {
            style: {
                fontSize: (isMobile ? 56 : 96) + "px",
            },
            primaryFill: tokens.colorNeutralForeground3,
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))))),
    })), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(singleton(["display", "flex"]), delay(() => append_1(singleton(["flexGrow", 1]), delay(() => append_1(singleton(["padding", 15]), delay(() => append_1(singleton(["gap", 15 + "px "]), delay(() => append_1(singleton(["minWidth", 0]), delay(() => append_1(singleton(["boxSizing", "border-box"]), delay(() => {
        const matchValue_1 = screenSize;
        switch (matchValue_1.tag) {
            case 0:
            case 1:
                return singleton(["flexDirection", "column"]);
            default:
                return append_1(singleton(["flexDirection", "row"]), delay(() => append_1(singleton(["flexWrap", "wrap"]), delay(() => singleton(["justifyContent", "space-between"])))));
        }
    })))))))))))))))], (elems_19 = [createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => {
        let matchValue_2;
        return append_1((matchValue_2 = screenSize, (matchValue_2.tag === 0) ? singleton(["width", 100 + "%"]) : ((matchValue_2.tag === 1) ? singleton(["width", 100 + "%"]) : singleton(["maxWidth", 60 + "%"]))), delay(() => append_1(singleton(["display", "flex"]), delay(() => append_1(singleton(["gap", 5 + "px "]), delay(() => append_1(singleton(["flexDirection", "column"]), delay(() => singleton(["justifyContent", "space-between"])))))))));
    })))], (elems_10 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 5 + "px ",
    }], (elems_5 = toList(delay(() => {
        let el_6;
        return append_1(singleton((el_6 = Subtitle2, createElement(el_6, {
            children: track.Name,
        }))), delay(() => {
            let el_11, matchValue_3, el_8;
            let fraction;
            const totalCompleted = allTasksInTrack.filter((t) => model.CompletedTasks.some((ct) => (ct.Task.Id === t.Id)));
            fraction = ((allTasksInTrack.length === 0) ? 0 : (totalCompleted.length / allTasksInTrack.length));
            return append_1(singleton((el_11 = Field, createElement(el_11, {
                validationMessage: `${~~(fraction * 100)} % fullført`,
                validationState: "none",
                children: (matchValue_3 = tryHead([(el_8 = ProgressBar, createElement(el_8, createObj(toList(delay(() => append_1(singleton(["thickness", "large"]), delay(() => append_1(singleton(["shape", "rounded"]), delay(() => append_1((model.IsInactive != null) ? singleton(["color", "error"]) : singleton(["color", "brand"]), delay(() => singleton(["value", fraction]))))))))))))]), (matchValue_3 == null) ? defaultOf() : matchValue_3),
            }))), delay(() => {
                let matchValue_4, cl, el_19, elems_4, elems_2, el_13, elems_3, el_15, el_17;
                return append_1((matchValue_4 = currentLevel, (matchValue_4 != null) ? ((cl = matchValue_4, singleton((el_19 = Card, createElement(el_19, createObj(ofArray([["appearance", "subtle"], ["style", {
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                }], (elems_4 = [createElement("div", createObj(singleton_1((elems_2 = [(el_13 = CertificateRegular, createElement(el_13, {
                    fontSize: 28,
                    primaryFill: tokens.colorBrandStroke1,
                }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])))), createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                }], (elems_3 = [(el_15 = Caption1, createElement(el_15, {
                    children: "Ditt nivå",
                })), (el_17 = Text$, createElement(el_17, {
                    children: `${cl.Name}`,
                }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])]))))))) : (empty())), delay(() => {
                    let el_21;
                    return append_1(singleton((el_21 = Text$, createElement(el_21, {
                        children: track.Description,
                        style: {
                            color: tokens.colorNeutralForeground3,
                        },
                    }))), delay(() => {
                        const matchValue_5 = model.IsInactive;
                        if (matchValue_5 != null) {
                            const overview = matchValue_5;
                            return singleton(createElement(View, {
                                trackOverview: overview,
                                completedTasks: model.CompletedTasks,
                            }));
                        }
                        else {
                            return empty();
                        }
                    }));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        gap: 20 + "px ",
        flexWrap: "wrap",
    }], (elems_9 = toList(delay(() => {
        let elems_6, el_23, el_25;
        return append_1(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
            gap: 5 + "px ",
        }], (elems_6 = [(el_23 = LayerRegular, createElement(el_23, {
            fontSize: 24,
            primaryFill: tokens.colorBrandBackground,
        })), (el_25 = Label, createElement(el_25, {
            size: "medium",
            style: {
                color: tokens.colorNeutralForeground3,
            },
            children: `${track.TrackLevels.length} nivåer`,
        }))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))), delay(() => {
            let el_32, matchValue_6, elems_7, el_27, el_29;
            return (model.IsInactive != null) ? singleton((el_32 = Tooltip, createElement(el_32, createObj(ofArray([["content", "Dette læringsløpet er inaktivt og nødvendige kurs trengs å gjennomføres for å låse opp"], (matchValue_6 = tryHead([createElement("div", createObj(ofArray([["style", {
                display: "flex",
                alignItems: "center",
                gap: 5 + "px ",
            }], (elems_7 = [(el_27 = WarningFilled, createElement(el_27, {
                fontSize: 20,
                primaryFill: tokens.colorStatusDangerBackground3,
            })), (el_29 = Label, createElement(el_29, {
                size: "medium",
                style: {
                    color: tokens.colorNeutralForeground3,
                },
                children: "Inaktivt",
            }))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))]), (matchValue_6 == null) ? ["children", defaultOf()] : ["children", matchValue_6])]))))) : empty();
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_9))])])))], ["children", reactApi.Children.toArray(Array.from(elems_10))])]))), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(singleton(["display", "flex"]), delay(() => append_1(singleton(["flexDirection", "column"]), delay(() => {
        let matchValue_7;
        return append_1((matchValue_7 = screenSize, (matchValue_7.tag === 0) ? singleton(["flexGrow", 1]) : ((matchValue_7.tag === 1) ? singleton(["flexGrow", 1]) : (empty()))), delay(() => singleton(["gap", 5 + "px "])));
    })))))))], (elems_18 = toList(delay(() => {
        let el_34;
        return append_1(equals(ctx.User.Role, new Role(1, [])) ? singleton((el_34 = Button, createElement(el_34, {
            children: "Rediger",
            appearance: "primary",
            onClick: (_arg_1) => {
                RouterModule_nav(ofArray(["laeringslop", "bygger", `${track.Id}`]), 1, 1);
            },
        }))) : empty(), delay(() => {
            let el_40, el_66, elems_14, el_48, el_46, props_101, props_99, el_50, el_54, elems_11, el_52, el_58, elems_12, el_56, el_64, elems_13, el_62, name_16, name_18, elemsToUse;
            return append_1((model.EnrolledTrack == null) ? singleton((el_40 = Button, createElement(el_40, createObj(toList(delay(() => {
                let el_36, el_38;
                return append_1(isEnrollmentPending ? singleton(["icon", (el_36 = Spinner, createElement(el_36, {
                    size: "tiny",
                }))]) : singleton(["icon", (el_38 = ArrowRightRegular, createElement(el_38, {}))]), delay(() => append_1(singleton(["iconPosition", "after"]), delay(() => append_1(singleton(["children", "Meld på"]), delay(() => append_1(singleton(["appearance", "primary"]), delay(() => append_1(singleton(["disabled", (isEnrollmentPending ? true : !track.Enabled) ? true : !trackInWorkplace]), delay(() => singleton(["onClick", (_arg_2) => {
                    setIsEnrollmentPending(true);
                    const pr = tap((res) => {
                        setIsEnrollmentPending(false);
                        if (res.tag === 1) {
                            switch (res.fields[0].tag) {
                                case 2: {
                                    infoToast(setCtx, "alreadySignedUpError", "Allerede påmeldt", `Du er allerede påmeldt ${track.Name}`, undefined);
                                    break;
                                }
                                case 1: {
                                    infoToast(setCtx, "disabledError", "Kunne ikke melde på", "Læringsløpet er ikke publisert", undefined);
                                    break;
                                }
                                case 3: {
                                    infoToast(setCtx, "WorkplaceTrackNotSet", "Kunne ikke melde på", "Læringsløpet er ikke tilgjengelig for din arbeidsplass", undefined);
                                    break;
                                }
                                default:
                                    errorToast(setCtx, "signUpError", "Kunne ikke melde på", "Noe gikk galt", undefined);
                            }
                        }
                        else {
                            dispatch(new Msg(1, [res.fields[0]]));
                            successToast(setCtx, "signUpSuccess", "Påmeldt", `Du ble påmeldt ${track.Name}`);
                        }
                    }, startAsPromise(Track.SignUp(track.Id)));
                    void (pr.catch((ex) => {
                        setIsEnrollmentPending(false);
                        toastServerError(setCtx, ex);
                    }));
                }])))))))))));
            })))))) : ((model.EnrolledTrack != null) ? singleton((el_66 = Dialog, createElement(el_66, createObj(ofArray([["open", patternInput_2[0]], ["onOpenChange", (_arg_3, value_1_20) => {
                if (!isEnrollmentPending) {
                    setIsSignOffDialogOpen(value_1_20.open);
                }
            }], (elems_14 = [(el_48 = DialogTrigger, createElement(el_48, {
                children: (el_46 = Button, createElement(el_46, createObj(toList(delay(() => {
                    let el_42, el_44;
                    return append_1(isEnrollmentPending ? singleton(["icon", (el_42 = Spinner, createElement(el_42, {
                        size: "tiny",
                    }))]) : singleton(["icon", (el_44 = ArrowExitRegular, createElement(el_44, {}))]), delay(() => append_1(singleton(["iconPosition", "after"]), delay(() => append_1(singleton(["children", "Meld av"]), delay(() => append_1(singleton(["appearance", "primary"]), delay(() => singleton(["disabled", (isEnrollmentPending ? true : !track.Enabled) ? true : !trackInWorkplace])))))))));
                }))))),
            })), (props_101 = singleton_1((props_99 = ofArray([(el_50 = DialogTitle, createElement(el_50, {
                children: `Meld av ${track.Name}`,
            })), (el_54 = DialogContent, createElement(el_54, createObj(singleton_1((elems_11 = [(el_52 = Body1, createElement(el_52, {
                children: `Er du sikker på at du vil melde deg av læringsløpet "${track.Name}"?`,
            }))], ["children", reactApi_1.Children.toArray(Array.from(elems_11))]))))), (el_58 = DialogActions, createElement(el_58, createObj(ofArray([["position", "start"], (elems_12 = [(el_56 = Button, createElement(el_56, {
                children: "Avbryt",
                disabled: isEnrollmentPending,
                onClick: (_arg_4) => {
                    setIsSignOffDialogOpen(false);
                },
            }))], ["children", reactApi_1.Children.toArray(Array.from(elems_12))])])))), (el_64 = DialogActions, createElement(el_64, createObj(ofArray([["position", "end"], (elems_13 = [(el_62 = Button, createElement(el_62, createObj(toList(delay(() => append_1(singleton(["children", "Meld av"]), delay(() => append_1(singleton(["appearance", "primary"]), delay(() => append_1(singleton(["disabled", isEnrollmentPending]), delay(() => {
                let el_60;
                return append_1(isEnrollmentPending ? singleton(["icon", (el_60 = Spinner, createElement(el_60, {
                    size: "tiny",
                }))]) : empty(), delay(() => singleton(["onClick", (_arg_5) => {
                    setIsEnrollmentPending(true);
                    const pr_1 = tap((res_1) => {
                        setIsEnrollmentPending(false);
                        if (res_1.tag === 1) {
                            if (res_1.fields[0].tag === 1) {
                                infoToast(setCtx, "notSignedUpError", "Ikke påmeldt", `Du er ikke påmeldt ${track.Name}`, undefined);
                            }
                            else {
                                errorToast(setCtx, "signOffError", "Kunne ikke melde av", "Noe gikk galt", undefined);
                            }
                        }
                        else {
                            setIsSignOffDialogOpen(false);
                            dispatch(new Msg(1, [undefined]));
                            successToast(setCtx, "signOffSuccess", "Avmeldt", `Du ble avmeldt ${track.Name}`);
                        }
                    }, startAsPromise(Track.SignOff(track.Id, ctx.User.Id)));
                    void (pr_1.catch((ex_1) => {
                        setIsEnrollmentPending(false);
                        toastServerError(setCtx, ex_1);
                    }));
                }])));
            })))))))))))], ["children", reactApi_1.Children.toArray(Array.from(elems_13))])]))))]), (name_16 = DialogBody, createElement(name_16, {
                children: reactApi.Children.toArray(Array.from(props_99)),
            })))), (name_18 = DialogSurface, createElement(name_18, {
                children: reactApi.Children.toArray(Array.from(props_101)),
            })))], (elemsToUse = ((length(elems_14) <= 2) ? elems_14 : take(2, elems_14)), ["children", reactApi_1.Children.toArray(elemsToUse)]))]))))) : empty()), delay(() => {
                let el_70;
                return append_1(singleton((el_70 = Link, createElement(el_70, createObj(toList(delay(() => append_1(singleton(["disabled", track.TrackLevels.length === 0]), delay(() => append_1((track.TrackLevels.length > 0) ? singleton(["href", formatLevelsRoute(map((_arg_6) => _arg_6.Id, track.TrackLevels, Int32Array))]) : empty(), delay(() => {
                    let elems_15, el_68;
                    return singleton((elems_15 = [(el_68 = Button, createElement(el_68, {
                        disabled: track.TrackLevels.length === 0,
                        children: "Se tilgjengelige kurs",
                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_15))]));
                })))))))))), delay(() => {
                    let el_72;
                    return append_1(equals(ctx.User.Role, new Role(1, [])) ? singleton((el_72 = Button, createElement(el_72, {
                        children: "Se påmeldte brukere",
                        appearance: "secondary",
                        onClick: (_arg_7) => {
                            RouterModule_nav(ofArray(["laeringslop", `${track.Id}`, "brukere"]), 1, 1);
                        },
                    }))) : empty(), delay(() => {
                        let el_88;
                        return !trackInWorkplace ? singleton((el_88 = Popover, createElement(el_88, createObj(toList(delay(() => append_1(isMobile ? singleton(["positioning", "below-start"]) : singleton(["positioning", "before"]), delay(() => {
                            let elems_17, el_78, children_2, el_76, el_74, el_86, elems_16, el_80, text_6, el_82, text_7, el_84, elemsToUse_1;
                            return singleton((elems_17 = [(el_78 = PopoverTrigger, createElement(el_78, {
                                children: (children_2 = singleton_1((el_76 = Button, createElement(el_76, {
                                    children: "Ikke tilgjengelig",
                                    iconPosition: "after",
                                    icon: (el_74 = ImportantFilled, createElement(el_74, {
                                        primaryFill: tokens.colorStatusDangerBackground3,
                                    })),
                                    appearance: "subtle",
                                }))), createElement("div", {
                                    children: reactApi.Children.toArray(Array.from(children_2)),
                                })),
                            })), (el_86 = PopoverSurface, createElement(el_86, createObj(ofArray([["style", {
                                display: "flex",
                                flexDirection: "column",
                                maxWidth: 400 + "px",
                            }], (elems_16 = [(el_80 = Subtitle2, createElement(el_80, {
                                children: "Læringsløp ikke tilgjengelig",
                            })), (text_6 = "Arbeidsplasser må ha en samarbeidsavtale med Invest In Play som beskriver hvilke læringsløp man kan ta.", (el_82 = Caption1, createElement(el_82, {
                                children: text_6,
                            }))), (text_7 = "Din arbeidsplass har ikke dette læringsløpet som del av sin avtale, og det vil ikke være mulig å melde seg på.", (el_84 = Caption1, createElement(el_84, {
                                children: text_7,
                            })))], ["children", reactApi_1.Children.toArray(Array.from(elems_16))])]))))], (elemsToUse_1 = ((length(elems_17) <= 2) ? elems_17 : take(2, elems_17)), ["children", reactApi_1.Children.toArray(elemsToUse_1)])));
                        })))))))) : empty();
                    }));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_18))])])))], ["children", reactApi.Children.toArray(Array.from(elems_19))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_20))])])));
}

export function TrackView(trackViewInputProps) {
    let elems_1;
    const trackId = trackViewInputProps.trackId;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    let patternInput_1;
    const arg_1 = init(tryFind((t) => (t.Track.Id === trackId), ctx.InactiveTracks));
    patternInput_1 = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const dependencies = [ctx.InactiveTracks];
    reactApi.useEffect(() => {
        dispatch(new Msg(5, [tryFind((t_1) => (t_1.Track.Id === trackId), ctx.InactiveTracks)]));
    }, dependencies);
    useEffectOnce(() => {
        const pr = tap((res) => {
            if (res.tag === 0) {
                dispatch(new Msg(4, [res.fields[0]]));
            }
            else {
                errorToast(setCtx, "getMyTasksError", "Noe gikk galt", "Kunne ikke hente mine gjennomførte oppgaver", undefined);
            }
        }, startAsPromise(Task.GetMyCompleted()));
        void (pr.catch((ex) => {
            toastServerError(setCtx, ex);
        }));
        const pr_1 = tap((res_1) => {
            if (res_1.tag === 1) {
                errorToast(setCtx, "getTracksError", "Kunne ikke hente læringsløp", "Noe gikk galt", undefined);
                dispatch(new Msg(3, [false]));
            }
            else {
                dispatch(new Msg(0, [res_1.fields[0]]));
            }
        }, startAsPromise(Track.Get(trackId)));
        void (pr_1.catch((ex_1) => {
            toastServerError(setCtx, ex_1);
        }));
        const pr_2 = tap((res_2) => {
            if (res_2.tag === 1) {
            }
            else {
                dispatch(new Msg(1, [tryFind((t_3) => (t_3.Track.Id === trackId), res_2.fields[0])]));
            }
        }, startAsPromise(Track.GetMy()));
        void (pr_2.catch((ex_2) => {
            toastServerError(setCtx, ex_2);
        }));
        const pr_3 = tap((res_3) => {
            if (res_3.tag === 1) {
            }
            else {
                dispatch(new Msg(2, [res_3.fields[0]]));
            }
        }, startAsPromise(Workplace.GetWorkplacesForTrack(trackId)));
        void (pr_3.catch((ex_3) => {
            toastServerError(setCtx, ex_3);
        }));
    });
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        width: 100 + "%",
        flexGrow: 1,
        gap: 25 + "px ",
    }], (elems_1 = toList(delay(() => {
        let el_4, elems, el, el_2;
        const matchValue = model_1.Track;
        if (matchValue != null) {
            const track$0027 = matchValue;
            return append_1(singleton(createElement(HeaderCard, {
                track: track$0027,
                model: model_1,
                dispatch: dispatch,
            })), delay(() => {
                const matchValue_1 = model_1.EnrolledTrack;
                if (matchValue_1 == null) {
                    return empty();
                }
                else {
                    const isInactive_1 = model_1.IsInactive != null;
                    return singleton(createElement(TrackProgress, new TrackProgressProps(matchValue_1, map((_arg_2) => _arg_2.Task, model_1.CompletedTasks), (task) => {
                        completeTrackLevelTask(task.Id, ctx.User.Id, model_1, dispatch, setCtx);
                    }, (task_1) => {
                        removeTrackLevelTask(task_1.Id, ctx.User.Id, model_1, dispatch, setCtx);
                    }, isInactive_1)));
                }
            }));
        }
        else {
            return model_1.IsFetching ? singleton((el_4 = Skeleton, createElement(el_4, createObj(ofArray([["style", {
                width: 100 + "%",
                display: "flex",
                flexDirection: "column",
                gap: 25 + "px ",
            }], (elems = [(el = SkeletonItem, createElement(el, {
                style: {
                    height: 35 + "vh",
                },
                animation: "wave",
                shape: "rectangle",
            })), (el_2 = SkeletonItem, createElement(el_2, {
                style: {
                    height: 55 + "vh",
                },
                animation: "wave",
                shape: "rectangle",
            }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])]))))) : singleton(dataFetchFailedView());
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

//# sourceMappingURL=TrackView.jsx.map
